/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
import React from 'react';
import { Key, EyeOff, Cpu, Bot } from 'lucide-react';

export const Terminology = () => (
  <div className="space-y-8">
    <p className="text-lg text-stone-600 dark:text-stone-300 leading-relaxed font-medium">
      Key concepts to help you navigate the GhostPay ecosystem.
    </p>
    <div className="space-y-4">
        {[
            { icon: Key, title: "Non-Custodial", desc: "You have full control. We don't hold your funds or keys—only you do." },
            { icon: EyeOff, title: "Stealth Address", desc: "A unique, one-time address for each payment. This breaks the link between transactions, keeping your financial history private." },
            { icon: Cpu, title: "GhostOS", desc: "The secure engine behind GhostPay. It processes payments and checks data privately, keeping your details off the public record." },
            { icon: Bot, title: "x402 Micropayments", desc: "A protocol for AI agents to pay for API services and data instantly using crypto." }
        ].map((item, i) => (
            <div key={i} className="flex gap-5 p-5 rounded-xl bg-white dark:bg-white/5 border border-stone-100 dark:border-white/10 shadow-sm hover:shadow-md transition-all">
                <div className="flex-shrink-0 w-12 h-12 bg-stone-100 dark:bg-white/10 rounded-lg flex items-center justify-center text-stone-900 dark:text-white">
                    <item.icon size={24} />
                </div>
                <div>
                    <h4 className="font-serif font-bold text-lg text-stone-900 dark:text-white mb-2">{item.title}</h4>
                    <p className="text-stone-600 dark:text-stone-400 text-sm leading-relaxed">{item.desc}</p>
                </div>
            </div>
        ))}
    </div>
  </div>
);